module.exports = function() {
  return new Worker(__webpack_public_path__ + "8a257726bd6441a0525c.worker.js");
};